import { useEffect, useMemo, useRef, useState, useContext } from 'react';
import { MantineReactTable, useMantineReactTable } from 'mantine-react-table';
import axios from '../../axios';
import AuthContext from '../../AuthContext';
import { Menu, Paper, Button } from '@mantine/core';
import {toast} from 'react-toastify'
const Example = ({ updateProductModalSetting, handlePageUpdate }) => {
  const { centre, userType } = useContext(AuthContext);
  const [order, setOrder] = useState('');

  const columns = useMemo(() => {
    const baseColumns = [
      {
        accessorKey: 'financial_year',
        header: 'Financial Year',
        size: 200,
      },
      {
        accessorKey: 'sanction_order_no',
        header: 'Sanction order No.',
        size: 200,
      },
      {
        accessorKey: 'client_details',
        header: 'Client Details/ Sponsoring Agency',
        size: 200,
      },
      {
        accessorKey: 'tot_training_target_allocated',
        header: 'Total Training Target Allocated',
        size: 200,
      },
      {
        accessorKey: 'name_of_training_program',
        header: 'Name of the Training Programme',
        size: 200,
      },
      {
        accessorKey: 'project_duration',
        header: 'Duration of the Project',
        size: 200,
      },
      {
        accessorKey: 'project_cost',
        header: 'Cost of the Project',
        size: 200,
      },
      {
        accessorKey: 'project_location',
        header: 'Location of the Project',
        size: 200,
      },
      {
        accessorKey: 'remark',
        header: 'Remarks',
        size: 200,
      },
    ];

    // Add the "Centre Name" column if userType is Superadmin
    if (userType === 'Superadmin'||userType==='Manager') {
      baseColumns.unshift({
        accessorKey: 'centre_name',
        header: 'Centre Name',
        size: 200,
      });
    }

    return baseColumns;
  }, [userType]);

  const rowVirtualizerInstanceRef = useRef(null);
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [sorting, setSorting] = useState([]);

  useEffect(() => {
    axios
      .post('/sanctionorder/getAll', { centre_id: centre })
      .then((res) => {
        setData(res.data);
        setOrder(res.data.upload_sanction_order_file ? `${Image}/${res.data.upload_sanction_order_file}` : '');
      })
      .catch((err) => console.log(err))
      .finally(() => setIsLoading(false));
  }, [handlePageUpdate, centre]);

  useEffect(() => {
    try {
      rowVirtualizerInstanceRef.current?.scrollToIndex(0);
    } catch (e) {
      toast.error('Something went wrong')
      console.log(e);
    }
  }, [sorting]);

  const table = useMantineReactTable({
    data,
    columns,
    enableGlobalFilter: true,
    enableColumnFilterModes: true,
    enablePinning: true,
    enablePagination: true,
    enableMultiSort: true, 
    columnFilterDisplayMode:"popover",
    paginationDisplayMode:"pages",
    positionToolbarAlertBanner:"bottom",
    enableColumnResizing: true,
    enableColumnFilter: true,
    enableColumnSelection: true,
    enableGlobalFilter: true,
    enableGlobalFilterModes: true,
    enableStickyHeader: true,
    enableColumnSticky: true,
    enableRowNumbers: true,
    enableRowActions: true,
    renderRowActionMenuItems: ({ row }) => (
      <>
        <Menu.Item onClick={() => updateProductModalSetting(row.original)}>Edit</Menu.Item>
      </>
    ),
  });

  return (
    <Paper shadow="sm" p="lg" withBorder>
      <div style={{width: '100%' }}>
        <MantineReactTable
          table={table}
          striped
          highlightOnHover
          horizontalSpacing="md"
          verticalSpacing="sm"
          fontSize="sm"
          withColumnBorders
          borderRadius="md"
          withGlobalFilter
          height={400}
          rowVirtualizerInstanceRef={rowVirtualizerInstanceRef}
          enablePagination={true}
        />
      </div>
    </Paper>
  );
};

export default Example;
